

import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './experiences.css';

const experiencesData = [
    
    {
        title: 'Frontend Developer',
        desc: 'A front-end developer builds the front-end portion of websites and web applications—that is, the part that users actually see and interact with. A front-end developer creates websites and applications using web languages such as HTML, CSS, and JavaScript allow users to access and interact with the site or app.',
    },
]

const experiencesDatas = [
    {
        title: 'Backend Developer',
        desc: 'Backend development means working on server-side software, which focuses on everything you can\'t see on a website. Back-end developers ensure the website performs correctly, focusing on databases, back-end logic, application programming interface (APIs), architecture, and servers',
    },
]

const Experiences = () => {
  return (
    <section>
        <Container>
            <Row>
                <Col lg='12' className='mb-5'>
                    <h2>My Experience</h2>
                </Col>

                <Col lg='6' md='6'>
                    <div className="experience-conatiner">
                        {
                            experiencesData.map((item, index)=>(
                                <ExperiencesItem
                                    key={index}
                                    title={item.title}
                                    desc={item.desc}
                                />
                            ))
                        }
                    </div>
                </Col>

                <Col lg='6' md='6'>
                    <div className="experience-conatiner">
                        {
                            experiencesDatas.map((item, index)=>(
                                <ExperiencesItem
                                    key={index}
                                    year={item.year}
                                    title={item.title}
                                    desc={item.desc}
                                />
                            ))
                        }
                    </div>
                </Col>
            </Row>
        </Container>
    </section>
  )
}


const ExperiencesItem = ({title, desc})=>{
    return <div className="single-experience">
    <span className='experience-icon'><i className="ri-book-open-fill"></i></span>
    <h5>{title}</h5>
    <p>{desc}</p>
</div>
}

export default Experiences